import axios, { parseCursor } from '@/base/api/axios'
import { toFormData } from '@/utils/utils'

export default {

  async create (data) {
    return (await axios.post('/api/messages/', await toFormData(data))).data
  },

  async save (data) {
    return (await axios.patch(`/api/messages/${data.id}/`, await toFormData(data))).data
  },

  async markThread (messageId, seenUpTo) {
    return (await axios.patch(`/api/messages/${messageId}/thread/`, {
      seenUpTo,
    })).data
  },

  async setMuted (messageId, muted) {
    return (await axios.patch(`/api/messages/${messageId}/thread/`, {
      muted,
    })).data
  },

  async get (id) {
    return (await axios.get(`/api/messages/${id}/`)).data
  },

  async list (conversationId, { cursor, pageSize, order } = {}) {
    const response = (await axios.get(
      '/api/messages/',
      { params: { conversation: conversationId, cursor, page_size: pageSize, order } },
    )).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async listThread (thread, { cursor, pageSize, order } = {}) {
    const response = (await axios.get(
      '/api/messages/',
      { params: { thread, cursor, page_size: pageSize, order } },
    )).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async listMyThreads (filter) {
    const response = (await axios.get('/api/messages/my_threads/', { params: filter })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },
}
